import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Nowy modyfikator',
  tabs: {
    [Tab.General]: 'Ogólne',
    [Tab.NutritionInfo]: 'Informacje żywieniowe',
  },
  form: {
    modifier_groups: {
      label: 'Należy do grup modyfikatorów',
    },
    name: {
      label: 'Nazwa',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: 'Ref {{integration}}',
      placeholder: 'np. referencja SKU HubRise',
      read_only_hint: 'Edytowalne tylko gdy integracja HubRise jest aktywna i synchronizacja menu wyłączona.',
    },
    price: {
      label: 'Cena bazowa',
      placeholder: 'Opcjonalnie',
    },
    is_available: {
      label: 'Dostępne w magazynie',
    },
    is_visible: {
      label: 'Widoczne',
      title: 'Widoczne w menu',
      subtitle_on: 'Klienci mogą zobaczyć tę opcję',
      subtitle_off: 'Ukryte dla wszystkich klientów',
    },
    is_available_for_pickup: {
      label: 'Dostępne na odbiór',
      subtitle_on: 'Klienci mogą zamówić na odbiór',
      subtitle_off: 'Ukryte z menu odbioru',
    },
    is_available_for_delivery: {
      label: 'Dostępne na dostawę',
      subtitle_on: 'Klienci mogą zamówić z dostawą',
      subtitle_off: 'Ukryte z menu dostawy',
    },
  },
  availability: {
    title: 'Dostępność',
    helper:
      'Widoczność to główny przełącznik. Wyłącz kanał, aby ukryć tę opcję przed klientami odbierającymi lub zamawiającymi dostawę bez usuwania jej z menu.',
    status: {
      both: 'Oba kanały',
      pickup_only: 'Tylko odbiór',
      delivery_only: 'Tylko dostawa',
      hidden: 'Ukryte',
      no_channels: 'Brak kanałów',
    },
    warning: {
      no_channels: 'Ta opcja jest widoczna, ale niedostępna na żadnym kanale — klienci nie będą mogli jej wybrać.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Tylko odbiór',
      delivery_only: 'Tylko dostawa',
      no_channels: 'Brak kanałów',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    changes_got_saved: 'Zmiany zostały zapisane!',
  },
};
